<div class="container">
    <div class="row justify-content-center">
        <div class="form-group row justify-content-center my-5">
            <div class="col paso" *ngFor="let step of activeFases; let i = index">
                <div class="mb-3">
                    <span
                        class="h5 rounded rounded-circle text-white px-3 py-2"
                        [ngClass]="{'bg-process': step.number > fase, 'bg-warning': step.number === fase, 'bg-success': step.number < fase || petition?.processStatus === 'Completed'}">
                        {{i + 1}}
                    </span>
                </div>
                <span class="label-step">{{step.title}}</span>
            </div>
            <span class="barra float"></span>
        </div>
    </div>
</div>

